(function() {
angular.module('app.ui.form.ctrls')
.controller('TagsDemoCtrl', [
    '$scope', function($scope) {
      return $scope.tags = ['foo', 'bar'];
    }
  ]);
}());


// WEBPACK FOOTER //
// ./scripts/form/TagsDemoCtrl.js